import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { CTAButton } from "./CTAButton";
import { IMAGES } from "@/data/content";

export const FinalCTA = () => {
  return (
    <section data-testid="final-cta" className="relative overflow-hidden py-24 sm:py-32">
      <div className="absolute inset-0 -z-10">
        <img src={IMAGES.hero} alt="" className="h-full w-full object-cover opacity-30" />
      </div>
      <div className="absolute inset-0 -z-10 bg-brand-bg/80" />
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(80%_60%_at_50%_120%,rgba(46,240,138,0.22),transparent)]" />

      <div className="mx-auto max-w-4xl px-5 text-center lg:px-8">
        <Reveal>
          <span className="font-heading text-xs font-semibold uppercase tracking-[0.24em] text-brand-green">
            Kostenloses Online-Webinar
          </span>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 font-heading text-[2.6rem] font-extrabold leading-[1.03] tracking-tight sm:text-6xl lg:text-7xl">
            Finde heraus, ob Fahrzeug­überführung{" "}
            <span className="text-gradient-brand">zu dir passt.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mx-auto mt-6 max-w-2xl font-body text-base leading-relaxed text-white/70 sm:text-lg">
            Bevor du einfach irgendwo anfängst, solltest du verstehen, wie das Geschäft funktioniert,
            welche Kosten entstehen können und woran du einen guten Auftrag erkennst. Genau das zeige
            ich dir im kostenlosen Webinar.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <motion.div
            whileInView={{ scale: [0.96, 1] }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="mt-10 flex flex-col items-center gap-4"
          >
            <CTAButton testId="final-cta-button" className="w-full max-w-md sm:w-auto" />
            <p className="font-heading text-sm font-semibold uppercase tracking-[0.2em] text-white/50">
              Kostenlos • Online • Für Einsteiger
            </p>
          </motion.div>
        </Reveal>
      </div>
    </section>
  );
};
